
import { IUserSession } from '../../../helpers/user-session'

import { LoggerService } from '../../common/common.module'

import { OperatorGroupCreateEditController } from './operator-group-create-edit-popup.controller'

import { OperatorGroupHelper } from '../operator-group-helper'

//#region Asset Imports

import * as TEMPLATE from './operator-group-create-edit-popup.tpl.html'

//#endregion

// #region Setup

export class OperatorCreateEditDirective implements ng.IDirective {

    restrict = 'E'

    controller = ['$scope', '$q', '$timeout', 'logger',  'userSession', (
            $scope: any, 
            $q: ng.IQService, 
            $timeout: ng.ITimeoutService, 
            logger: LoggerService,
            userSession: IUserSession
        ) => new OperatorGroupCreateEditController(
            $scope, 
            $q, 
            $timeout, 
            logger, 
            userSession,
            OperatorGroupHelper.REFERENCE_TYPE,
            OperatorGroupHelper.SIMAX_MODULE_NAME 
        )]
            
    template = TEMPLATE
}

// #endregion